import { Dispatch, FC, SetStateAction } from "react";

interface BurgerMenuIconSVGProps {
    burgerMenuOpened: boolean;
    setBurgerMenuOpened: Dispatch<SetStateAction<boolean>>;
    className?: string;
}

const BurgerMenuIconSVG: FC<BurgerMenuIconSVGProps> = (props) => {
    return (
        <>
            <svg
                className={`${props.className} ${
                    props.burgerMenuOpened
                        ? "opacity-100 visible pointer-events-auto"
                        : "opacity-0 invisible pointer-events-none"
                }`}
                onClick={() => props.setBurgerMenuOpened(false)}
                width="29"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 1.5L9 9.5M17 17.5L9 9.5M9 9.5L17 1.5L1 17.5"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            <svg
                className={`${props.className} ${
                    props.burgerMenuOpened
                        ? "opacity-0 invisible pointer-events-none"
                        : "opacity-100 visible pointer-events-auto"
                }`}
                onClick={() => props.setBurgerMenuOpened(true)}
                width="29"
                height="19"
                viewBox="0 0 29 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.72021 1.5H28"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.72021 9.5H28"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.72021 17.5H28"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </>
    );
};

export default BurgerMenuIconSVG;
